export default {
    "API_URL": window.API_URL ? window.API_URL:  "https://faqqa.earlysalary.com/faqserver",
  };
